let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kdgMq")).then(() => parcelRequire('h0iV6'));